<template>
  <div class="bg">
    <div class="content pa bg_fff" @click.stop>

      <div class="title f_18 color_40 font_w_b" v-if="tipsTitle">{{ tipsTitle }}</div>
      <div class="text f_14 color_60" v-if="tipsText">{{ tipsText }}</div>
      <div class="text f_14 color_60" v-if="tipsTextHtml" v-html="tipsTextHtml"></div>

      <div class="formButtons templateButtons text_center clearfix">
        <div class="confirmButton f_14 fr" @click="confirmFunc">{{ confirmButtonText || '确认' }}</div>
        <div class="cancelButton f_14 fr" @click="cancelFunc">{{ cancelButtonText || '取消' }}</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name:'TipsBlock',
  data(){
    return {
    }
  },
  props:{
    tipsTitle:{
      type: String
    },
    tipsText:{
      type: String
    },
    tipsTextHtml:{
      type: String
    },
    confirmButtonText: {
      type: String,
      default: '确认'
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    }
  },
  methods:{
    confirmFunc(){
      this.$emit('confirmFunc')
    },
    cancelFunc(){
      this.$emit('cancelFunc')
    },
  },
}
</script>

<style lang="scss" scoped>
  .bg{
    position: fixed;
    z-index: 303;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,.5);
    .content{
      width:446px;
      box-sizing: border-box;
      box-shadow:0px 1px 3px 0px rgba(0,0,0,0.03);
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%);
      padding: 32px 32px 26px;
      border-radius: 8px;

      .title{
        color: #404040;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        margin-bottom: 12px;
      }
      .text{
        color: #606060;
        line-height: 24px;
        margin-bottom: 26px;
      }
    }
  }
  .formButtons{
    margin-top: 25px;

    >div {
      cursor: pointer;
      line-height: 36px;
      border-radius: 4px;
      height: 36px;
      padding: 0 28px;

      &:hover {
        opacity: 0.8;
      }
    }

    .confirmButton{
      width: auto;
      margin-left: 16px;
      background: #ff6644;
      color: #ffff;
    }

    .cancelButton{
      width: auto;
      border: 1px solid #d9d9d9;
      color: #606060;
      background-color: #FFffff;
    }

  }
</style>